import React from 'react'
import { DjayIllustrationProps } from './types'

// Onboarding
import { FirstStepsIllustration } from './achievements/FirstStepsIllustration'
import { GettingStartedIllustration } from './achievements/GettingStartedIllustration'
import { CenturyIllustration } from './achievements/CenturyIllustration'

// Streaks
import { ThreeDaysIllustration } from './achievements/ThreeDaysIllustration'
import { WeekChampionIllustration } from './achievements/WeekChampionIllustration'
import { FireMasterIllustration } from './achievements/FireMasterIllustration'
import { HotStreakIllustration } from './achievements/HotStreakIllustration'
import { UnstoppableIllustration } from './achievements/UnstoppableIllustration'
import { LegendaryStreakIllustration } from './achievements/LegendaryStreakIllustration'
import { UnbreakableIllustration } from './achievements/UnbreakableIllustration'

// Mastery
import { FirstSubjectIllustration } from './achievements/FirstSubjectIllustration'
import { ThreeSubjectsIllustration } from './achievements/ThreeSubjectsIllustration'
import { AllSubjectsIllustration } from './achievements/AllSubjectsIllustration'

// Levels
import { Level5Illustration } from './achievements/Level5Illustration'
import { Level10Illustration } from './achievements/Level10Illustration'
import { Level15Illustration } from './achievements/Level15Illustration'

// Special
import { ShadowRealmIllustration } from './achievements/ShadowRealmIllustration'
import { GoalGetterIllustration } from './achievements/GoalGetterIllustration'
import { ConsistentIllustration } from './achievements/ConsistentIllustration'
import { PerfectionistIllustration } from './achievements/PerfectionistIllustration'

export * from './types'
export * from './DjayIllustrationBase'

// Registry mapping achievement IDs to their specific illustrations
const ILLUSTRATION_REGISTRY: Record<
  string,
  React.ComponentType<DjayIllustrationProps>
> = {
  // Onboarding
  'first-steps': FirstStepsIllustration,
  'getting-started': GettingStartedIllustration,
  century: CenturyIllustration,

  // Streaks
  'three-days': ThreeDaysIllustration,
  'week-champion': WeekChampionIllustration,
  'fire-master': FireMasterIllustration,
  'hot-streak': HotStreakIllustration,
  unstoppable: UnstoppableIllustration,
  'legendary-streak': LegendaryStreakIllustration,
  unbreakable: UnbreakableIllustration,

  // Mastery
  'first-subject': FirstSubjectIllustration,
  'three-subjects': ThreeSubjectsIllustration,
  'all-subjects': AllSubjectsIllustration,

  // Levels
  'level-5': Level5Illustration,
  'level-10': Level10Illustration,
  'level-15': Level15Illustration,

  // Special
  'shadow-realm': ShadowRealmIllustration,
  'goal-getter': GoalGetterIllustration,
  consistent: ConsistentIllustration,
  perfectionist: PerfectionistIllustration,
}

/**
 * Returns the specific illustration component for an achievement, or null if not implemented yet.
 */
export function getAchievementIllustration(
  achievementId: string,
): React.ComponentType<DjayIllustrationProps> | null {
  return ILLUSTRATION_REGISTRY[achievementId] || null
}
